import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { DropzoneArea } from 'mui-file-dropzone';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { v4 } from 'uuid';
import './f.extensions';
const DialogFicheiro = ({ onClose, allowed, initial, folder, service, ...props }) => {
    const [files, setFiles] = useState(null);
    const [loading, setLoading] = useState(true);
    const paramSchema = yup.object({
        file: yup.string().required('O campo é obrigatório'),
        designacao: yup.string().required('O campo é obrigatório')
    });
    const formik = useFormik({
        initialValues: {},
        validationSchema: paramSchema,
        validateOnMount: false,
        onSubmit: async (d) => {
            // Carrega ficheiro se não é dummy (isto é, se não é o ficheiro inicial)
            if (files.dummy == false) {
                // Upload file
                await service.uploadFicheiro('Upload', folder, files);
            }
            else {
                // O dropzone faz weird shits, por isso se dummy, garante-se o nome do ficheiro...
                d.file = initial.file;
            }
            onClose(d);
        }
    });
    const prep = async (initial) => {
        if (initial) {
            if (initial && initial.designacao) {
                formik.setFieldValue('designacao', initial.designacao);
            }
            if (initial.file) {
                // Load file
                let f = new File([], initial.file, { type: service.mimeTypeFicheiro(initial.file) });
                f.dummy = true;
                setFiles(f);
                formik.setFieldValue('file', initial.file);
            }
            setLoading(false);
        }
        else {
            setLoading(false);
        }
    };
    useEffect(() => {
        formik.resetForm();
        prep(initial);
    }, [initial]);
    return (<Dialog {...props} fullWidth maxWidth={'lg'}>
      <DialogTitle>{props.title}</DialogTitle>
      {!loading && (<DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} xs={12}>
              <DropzoneArea initialFiles={[files]} filesLimit={1} dropzoneText='Arraste um ficheiro para esta janela ou clique para adicionar' onChange={files => {
                if (files.length > 0) {
                    let t = files.pop();
                    let f = new File([t], `${v4()}.${t.extension()}`, { type: t.type });
                    f.dummy = t.dummy || false;
                    formik.setFieldValue('file', f.name);
                    setFiles(f);
                }
                else {
                    formik.setFieldValue('file', undefined);
                    setFiles(null);
                }
            }} onDelete={_ => {
                formik.setFieldValue('file', undefined);
                setFiles(null);
            }} acceptedFiles={allowed} showFileNames={false} showAlerts={false} showPreviewsInDropzone={true} useChipsForPreview={true} previewChipProps={{
                color: 'default',
                variant: 'filled'
            }}/>
            </Grid>
            <Grid lg={12} xs={12}>
              {' '}
              <TextField label='Designação' name='designacao' fullWidth defaultValue={formik.values?.designacao} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.designacao && Boolean(formik.errors.designacao)} helperText={formik.touched.designacao && formik.errors.designacao}/>
            </Grid>
          </Grid>
        </DialogContent>)}
      <DialogActions>
        <Button type='button' onClick={() => onClose(undefined)}>
          Cancelar
        </Button>
        <Button disabled={files == null || !formik.isValid} onClick={() => {
            formik.submitForm();
        }} variant='contained'>
          OK
        </Button>
      </DialogActions>
    </Dialog>);
};
export default DialogFicheiro;
